"use strict";
exports.__esModule = true;
exports.useIsOverflow = exports.useLocales = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var DEFAULT_LOCALES = {
    warningMessage: 'There are some unsaved changes',
    loadingMessage: 'Please wait...',
    closeButtonLabel: 'Close',
    discardButtonLabel: 'Discard changes',
    saveButtonLabel: 'Save changes',
    noChangesMessage: "You're all good, no changes to be saved yet",
    disabledSaveButtonMessage: '',
    discardChangesDialog: {
        title: 'Discard your changes',
        message: "You have some unsaved changes. If you discard them now, you won't be able to recover them.",
        cancelButtonLabel: 'Continue editing',
        confirmButtonLabel: 'Discard now'
    }
};
var useLocales = function (locales) {
    return react_1.useMemo(function () {
        if (!locales || !Object.keys(locales).length) {
            return DEFAULT_LOCALES;
        }
        return tslib_1.__assign(tslib_1.__assign({}, DEFAULT_LOCALES), locales);
    }, [locales]);
};
exports.useLocales = useLocales;
var useIsOverflow = function (element, callback) {
    var _a = react_1.useState(undefined), isOverflow = _a[0], setIsOverflow = _a[1];
    react_1.useLayoutEffect(function () {
        var _a, _b;
        var trigger = function () {
            var _a, _b;
            var hasOverflow = Boolean(((element === null || element === void 0 ? void 0 : element.clientWidth) || 0) >
                (((_a = element === null || element === void 0 ? void 0 : element.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) || Number.MAX_VALUE) ||
                ((element === null || element === void 0 ? void 0 : element.clientHeight) || 0) >
                    (((_b = element === null || element === void 0 ? void 0 : element.parentElement) === null || _b === void 0 ? void 0 : _b.clientHeight) || Number.MAX_VALUE));
            if (hasOverflow !== isOverflow) {
                setIsOverflow(hasOverflow);
                if (callback)
                    callback(hasOverflow);
            }
        };
        // Adding listener to the parent of parent as it changes with changing width
        if (((_a = element === null || element === void 0 ? void 0 : element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) && 'ResizeObserver' in window) {
            new ResizeObserver(trigger).observe((_b = element === null || element === void 0 ? void 0 : element.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement);
        }
        if (element === null || element === void 0 ? void 0 : element.parentElement)
            trigger();
        return function () {
            var _a, _b;
            if (((_a = element === null || element === void 0 ? void 0 : element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) && 'ResizeObserver' in window) {
                new ResizeObserver(trigger).unobserve((_b = element === null || element === void 0 ? void 0 : element.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement);
            }
        };
    }, [callback, element, setIsOverflow, isOverflow]);
    return isOverflow;
};
exports.useIsOverflow = useIsOverflow;
//# sourceMappingURL=helpers.js.map